// extracted by mini-css-extract-plugin
export default {"container":"booleanField_container__RkBao","checkboxContainer":"booleanField_checkboxContainer__XOBwk","checkbox":"booleanField_checkbox__M2-nX"};